"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdtfConfig = void 0;
const sdk_sdtf_geometry_1 = require("@shapediver/sdk.sdtf-geometry");
const sdk_sdtf_primitives_1 = require("@shapediver/sdk.sdtf-primitives");
class SdtfConfig {
    constructor(config) {
        this.integrations = [
            new sdk_sdtf_primitives_1.SdtfPrimitiveTypeIntegration(),
            new sdk_sdtf_geometry_1.SdtfGeometryTypeIntegration(),
        ];
        if ((config === null || config === void 0 ? void 0 : config.integrations) !== undefined)
            this.integrations = config.integrations;
        this.authToken = config === null || config === void 0 ? void 0 : config.authToken;
    }
}
exports.SdtfConfig = SdtfConfig;
//# sourceMappingURL=SdtfConfig.js.map